// Author YuJiaBei
// Date 2021-01-05 08:33:12

class RepairOrigin {
constructor({
        id = null,
        name = '',
        code = '',
        isPlaned = '',
        originTableName = '',
        description = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.code = code;
    this.isPlaned = isPlaned;
    this.originTableName = originTableName;
    this.description = description;
}
}

function newEntity() {
return new RepairOrigin();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.em.repair.repairOrigin.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.repair.repairOrigin.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'isPlaned',
        label: 'label.em.repair.repairOrigin.grid.isPlaned',
        sortable: true,
        form: {
        type: 'boolean'
        }
        },
        {
        key: 'originTableName',
        label: 'label.em.repair.repairOrigin.grid.originTableName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.em.repair.repairOrigin.grid.description',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    nameFilter : "",
    codeFilter : "",
    isPlanedFilter : "",
    originTableNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.repair.repairOrigin.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.em.repair.repairOrigin.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'isPlanedFilter',
        label: 'label.em.repair.repairOrigin.filter.isPlaned',
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'originTableNameFilter',
        label: 'label.em.repair.repairOrigin.filter.originTableName',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.repair.repairOrigin.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'code',
        label: 'label.em.repair.repairOrigin.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'isPlaned',
        label: 'label.em.repair.repairOrigin.entity.isPlaned',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'originTableName',
        label: 'label.em.repair.repairOrigin.entity.originTableName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'description',
        label: 'label.em.repair.repairOrigin.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {RepairOrigin, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
